import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getHrReportStart,
  getHrReportSuccess,
  getHrReportFailed,
} from "../redux/getHrReport";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { SCREEN } from "helper/roleChecker/Screens";
import { formFilterHrReportSelector } from "../redux/selector";
import { getHrReportApi } from "core/http/service/timeKeeping";

function* getHrReportWork() {
  const { offset, limit } = yield select(
    controlInfinitiveScrollSelector("hrReport")
  );
  const form = yield select(formFilterHrReportSelector);

  const params = { offset, limit, ...form };
  try {
    const res = yield call(getHrReportApi, {
      ...params,
      screenCode: SCREEN.IP_021,
    });
    yield put({
      type: getHrReportSuccess.type,
      payload: {
        data: res.data,
        categoryName: res.categoryName,
        totalRecords: res.totalRecords,
        value: res?.value,
      },
    });
  } catch (error: any) {
    yield put({
      type: getHrReportFailed.type,
    });
  }
}

function* watchGetHrReport() {
  yield takeLatest(getHrReportStart.type, getHrReportWork);
}

export default function* getHrReportSaga() {
  yield all([watchGetHrReport()]);
}
